import { render, staticRenderFns } from "./Deals.vue?vue&type=template&id=55e5cd94&scoped=true&"
import script from "./Deals.vue?vue&type=script&lang=js&"
export * from "./Deals.vue?vue&type=script&lang=js&"
import style0 from "./Deals.vue?vue&type=style&index=0&id=55e5cd94&prod&lang=scss&scoped=true&"
import style1 from "./Deals.vue?vue&type=style&index=1&id=55e5cd94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e5cd94",
  null
  
)

export default component.exports